import React from 'react';

const TwoColumn = ({ children, className }) => {
  return (
    <div className={className || ''}>
      <div className="grid gap-5 lg:gap-8 lg:grid-cols-2 lg:-mx-20 xl:-mx-40">
        {React.Children.map(children, (child, index) => (
          <div
            key={`TwoColumn_${index}`}
            className="not-prose rounded-sm overflow-hidden isolate [&_p]:h-full [&_span]:h-full lg:col-span-1"
          >
            {React.isValidElement(child)
              ? React.cloneElement(child, {
                  /*any props want to pass to children*/
                })
              : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TwoColumn;
